import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, InteractionType, KeyValues3, KeyValues5, LocalService, OtpStatus, OtpType, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-otp-container',
  templateUrl: './otp-container.component.html',
  styleUrls: ['./otp-container.component.scss']
})
export class OtpContainerComponent implements OnInit {
  @Input() IsPopup: boolean = false; @Input() IsOtpPopup: boolean = false;
  @Input() PhNumOrEmail: string = ''; @Input() businessId = ''; @Input() interactionType: InteractionType = InteractionType.None;
  @Input() IsOtpSent: boolean = false; isShowOtp = true; @Input() isShowRequestOtp: boolean = false; @Input() requestOtpLabel: string;
  @Output() onFailed = new EventEmitter(); @Output() onNotAllowed = new EventEmitter();
  @Output() onVerified = new EventEmitter(); @Output() onBlocked = new EventEmitter(); @Output() onNew = new EventEmitter();
  @Output() onCancelled = new EventEmitter();
  @Output() onPasswordChanged = new EventEmitter(); @Input() otpType: OtpType = OtpType.None;
  lstSectionConfigKeys: string[] = ["otp_container"];
  @Input() additionalData?: KeyValues3;

  isPasswordPart: boolean = false;
  wrapper: KeyValues5 = {
    v1: null, v2: OtpType.None.toString(), v3: null
  } as KeyValues5;
  elementIds: any = {
    save: 'otp_container_save',
    otp: 'otp_container_otp',
    request: 'otp_container_request'
  };
  message: string = ''; isRedAlert: boolean = true;
  userId: string = '';

  constructor(public localService: LocalService, public profileManagementService: ProfileManagementService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.wrapper.v4 = this.businessId;
    this.wrapper.v5 = this.interactionType.toString();
    if (!this.isShowRequestOtp) {
      this.sendOtp();
    }
  }

  OnOtpFill(value) {
    this.message = '';
    this.wrapper.v1 = value;
    this.onVerify();
  }

  sendOtp() {
    if (!this.IsOtpSent) {
      this.isShowRequestOtp = false;
      this.wrapper.v3 = this.PhNumOrEmail && this.PhNumOrEmail != '' ? this.PhNumOrEmail : '-';
      this.wrapper.v2 = this.otpType.toString();
      this.profileManagementService.sendOtp(this.wrapper, this.additionalData).subscribe(result => {
        if (result.status == Status.UnAvailable) {
          this.onFailed.emit();
        } else if (result.status == Status.NotAllowed) {
          this.onNotAllowed.emit();
        } else if (result.status == Status.Blocked) {
          this.onBlocked.emit();
        } else if (result.status == Status.New) {
          this.onNew.emit();
        }
        this.localService.onFocusNextInput(this.elementIds.otp, FocusInputType.TextBox);
      });
    }
  }

  onVerify() {
    if (this.doCheck()) {
      this.profileManagementService.verifyOtp(this.wrapper, this.wrapper.v4.length > 3).subscribe(result => {
        this.isShowOtp = false;
        setTimeout(() => { this.isShowOtp = true; }, 100);
        if (result.status == OtpStatus.ChangePassword) {
          this.userId = result.id;
          this.onVerified.emit(this.userId);
          this.isPasswordPart = true;
        } else if (result.status == OtpStatus.InvalidValue) {
          this.message = this.localService.languageContent.otp_container.need_valid_otp;
          this.localService.onFocusNextInput(this.elementIds.otp, FocusInputType.TextBox);
        } else if (result.status == OtpStatus.Verified) {
          this.userId = result.id;
          this.onVerified.emit(this.userId);
        }
      });
    }
  }

  doCheck() {
    let message = '';
    if (this.wrapper.v1 == null) {
      message = this.localService.languageContent.otp_container.need_valid_otp;
      this.localService.onFocusNextInput(this.elementIds.otp, FocusInputType.TextBox);
    } else if (this.wrapper.v1.toString().trim().length != 6) {
      message = this.localService.languageContent.otp_container.need_valid_otp;
      this.localService.onFocusNextInput(this.elementIds.otp, FocusInputType.TextBox);
    }
    this.message = message;
    return message == '';
  }

  onPwdChanged($event) {
    this.onPasswordChanged.emit($event);
  }

  onCancel() {
    this.IsOtpPopup = false;
    this.onCancelled.emit();
  }
}
